import React, { FC, PropsWithChildren } from 'react';

import { useMediaSwitch, Stack, Button, ExternalLeft24, useDesktop } from 'Modules/ui3';
import { useTranslation } from 'Modules/core/i18n';

import { useNavigate } from '../../utils';


interface PageContainerProps {
    withMainButton?: boolean;
}


export const PageContainer: FC<PropsWithChildren<PageContainerProps>> = ({
    children, withMainButton,
}) => {
    const { t } = useTranslation('landingCommon');
    const toMain = useNavigate('/');
    const isDesktop = useDesktop();

    return (
        <Stack maxWidth='1440px' minWidth='320px' width='100%' px={useMediaSwitch(6, 8, 4)} mx='auto'>
            {withMainButton && (
                <Button
                    variant='text'
                    startIcon={<ExternalLeft24 />}
                    size='medium'
                    mb={isDesktop ? 8 : 4}
                    sx={{
                        alignSelf: 'flex-start',
                        color: 'grayscale.shade90',
                        fontWeight: 400,
                        height: ({ spacing }) => spacing(6),
                    }}
                    onClick={toMain}
                >
                    {t('buttons.toMain')}
                </Button>
            )}
            {children}
        </Stack>
    );
};
